import styled from "styled-components/macro";

export const Layout = styled.div`
	box-sizing: border-box;
	display: grid;
	grid-template-rows: 80px 1fr;
	height: 100%;
	min-height: 100vh;
`;

export const AuthForm = styled.form`
	display: grid;
`;
